import { Component, OnInit } from '@angular/core';
import {default as gridColumnsJSON} from '../common-grid/column-grid-json/front-running-column.json';
import { CommonGridComponent } from '../common-grid/common-grid.component';
@Component({
    selector: 'app-front-running',
    imports: [CommonGridComponent],
    templateUrl: './front-running.component.html',
    styleUrls: ['./front-running.component.scss']
})
export class FrontRunningComponent implements OnInit {
  gridColumns = gridColumnsJSON;
  constructor() { }

  ngOnInit() {
  }

}
